<template lang="pug">
head-meta(title-page="Страница не найдена", description="Проверьте ссылку на страницу, возможно она была удалена или перемещена " )
thanks-404(mod="error")
</template>

<script>
import Thanks404 from '../components/Thanks404'
import HeadMeta from '../components/_layout/HeadMeta'

export default {
  name: 'ErrorPage',
  components: { HeadMeta, Thanks404 }
}
</script>
